<div class="flex flex-row w-full min-h-screen">
    <div class="flex flex-col gap-2 w-32 sm:w-64 drop-shadow-lg" style="background: linear-gradient(#1A1922, #343346);">
        <a href="/" class="pt-4 pb-2 font-bold text-white text-center">
            Ponder
        </a>
        @if (canView) {
            <div class="p-2 flex flex-row gap-2 items-center justify-center bg-ponder-light shadow-inner hover:cursor-default text-sm">
                <div class="w-6 h-6 sm:w-8 sm:h-8 bg-center bg-no-repeat rounded-full magic-card-shadow" style="background-size: cover; background-image: url('{{ avatarUrl }}');">
                    
                </div>
                <div class="text-white">
                    {{ username }}
                </div>
            </div>
            <div class="flex flex-col grow pt-2 text-faded-80 text-center text-sm">
                <a href="/acp/alerts">
                    <div class="hover:text-white hover:cursor-pointer hover:font-bold w-full hover:bg-ponder-light p-2" [ngClass]="{'text-white font-bold' : isViewingAlerts() }">
                    Alerts
                    </div>
                </a>
                <a href="/acp/news">
                    <div class="hover:text-white hover:cursor-pointer hover:font-bold w-full hover:bg-ponder-light p-2" [ngClass]="{'text-white font-bold' : isViewingNews() }">
                    News
                    </div>
                </a>
                <a href="/acp/tasks">
                    <div class="hover:text-white hover:cursor-pointer hover:font-bold w-full hover:bg-ponder-light p-2" [ngClass]="{'text-white font-bold' : isViewingTasks() }">
                    Tasks
                    </div>
                </a>
                <a href="/acp/users">
                    <div class="hover:text-white hover:cursor-pointer hover:font-bold w-full hover:bg-ponder-light p-2" [ngClass]="{'text-white font-bold' : isViewingUsers() }">
                    Users
                    </div>
                </a>
                <a href="/acp/magic">
                    <div class="hover:text-white hover:cursor-pointer hover:font-bold w-full hover:bg-ponder-light p-2" [ngClass]="{'text-white font-bold' : isViewingMagic() }">
                    Magic
                    </div>
                </a>
            </div>
        }
    </div>
    <div class="flex flex-col grow bg-slate-200 p-2 sm:p-1 sm:pl-4 sm:pr-4 gap-4">
        @if (canView) {
            <router-outlet></router-outlet>
        }  @else {
            <admin-unauthorized></admin-unauthorized>
        }
    </div>
</div>